import Query from '../../../components/Report';

const query = new Query('search-urls-subdomains');

export default query;
